import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogCodeinfoComponent } from './dialog-codeinfo.component';
import { SharedModules } from 'src/app/shared.modules';

@NgModule({
  declarations: [DialogCodeinfoComponent],
  imports: [
    CommonModule,
    SharedModules
  ]
})
export class DialogCodeinfoModule { }
